var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_user_guide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ui-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ASSETS",
    transform: "translate(-232, -224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_usar_guide",
    transform: "translate(232, 224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1.333 C14.794,1.333 18.667,5.205 18.667,10 C18.667,14.794 14.794,18.666 10,18.666 C5.206,18.666 1.333,14.794 1.333,10 C1.333,5.205 5.206,1.333 10,1.333 M10,0 C4.485,0 0,4.485 0,10 C0,15.515 4.485,20 10,20 C15.515,20 20,15.515 20,10 C20,4.485 15.515,0 10,0",
    id: "Fill-1",
    fill: "#295299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,13.7775 C9.509,13.7775 9.111,14.1755 9.111,14.6665 C9.111,15.1575 9.509,15.5555 10,15.5555 C10.491,15.5555 10.889,15.1575 10.889,14.6665 C10.889,14.1755 10.491,13.7775 10,13.7775 M10,4.4445 C8.167,4.4445 6.667,5.9445 6.667,7.7775 C6.661,8.1455 6.956,8.4485 7.324,8.4535 C7.692,8.4585 7.995,8.1645 8,7.7965 C8,7.7905 8,7.7835 8,7.7775 C8,6.6655 8.888,5.7775 10,5.7775 C11.112,5.7775 12,6.6655 12,7.7775 C12,8.4035 11.778,8.8405 11.354,9.3195 C10.93,9.7975 10.295,10.2785 9.597,10.8055 C9.432,10.9305 9.334,11.1255 9.333,11.3335 L9.333,12.2215 C9.328,12.5905 9.622,12.8925 9.991,12.8985626 C10.359,12.9035 10.661,12.6085 10.667,12.2405 C10.667,12.2345 10.667,12.2285 10.667,12.2215 L10.667,11.6595 C11.266,11.2095 11.864,10.7615 12.354,10.2085 C12.917,9.5715 13.333,8.7575 13.333,7.7775 C13.333,5.9445 11.833,4.4445 10,4.4445",
    id: "Fill-4",
    fill: "#EC6524"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGuide);
export default __webpack_public_path__ + "static/media/ic_user_guide.30faabd5a5e52f9fae1923fbdfe958b6.svg";
export { ForwardRef as ReactComponent };